"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxSpending = exports.minSpending = exports.maxDumping = exports.minDumping = exports.maxQuote = exports.minQuote = exports.maxBase = exports.minBase = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
/**
 *  获取限价单最小下单量
 * */
const minBase = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.amount.min) || 0);
    if (!price || new trade_utils_lib_1.SafeDecimal(price).eq(0)) {
        return base;
    }
    // 投quote最小下单量
    const quote = ((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.min) || 0;
    const quoteToBase = new trade_utils_lib_1.SafeDecimal(quote).div(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.max(base, quoteToBase).toDecimalPlaces((_c = symbol.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
};
exports.minBase = minBase;
/**
 *  获取限价单最大下单量
 */
const maxBase = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.amount.max) || Number.MAX_VALUE);
    if (!price) {
        return base;
    }
    const quote = ((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.max) || Number.MAX_VALUE;
    const quoteToBase = new trade_utils_lib_1.SafeDecimal(quote).div(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.min(base, quoteToBase).toDecimalPlaces((_c = symbol.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
};
exports.maxBase = maxBase;
/**
 *  获取限价单最小下单quote
 */
const minQuote = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.amount.min) || 0);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.min) || 0);
    if (!price) {
        return quote;
    }
    const baseToQuote = base.mul(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.max(quote, baseToQuote).toDecimalPlaces((_c = symbol.precision) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
};
exports.minQuote = minQuote;
/**
 *  获取限价单最大下单quote
 *  */
const maxQuote = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.amount.max) || Number.MAX_VALUE);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.max) || Number.MAX_VALUE);
    if (!price) {
        return `${quote}`;
    }
    const baseToQuote = base.mul(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.min(quote, baseToQuote).toDecimalPlaces((_c = symbol.precision) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
};
exports.maxQuote = maxQuote;
/** 获取市价单最小下单量（投base）*/
const minDumping = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.min) || 0);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.min) || 0);
    if (!price) {
        return quote;
    }
    const quoteToBase = quote.div(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.max(base, quoteToBase).toDecimalPlaces((_c = symbol.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
};
exports.minDumping = minDumping;
/** 获取市价单最大下单量（投base）*/
const maxDumping = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.max) || Number.MAX_VALUE);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.max) || Number.MAX_VALUE);
    if (!price) {
        return quote;
    }
    const quoteToBase = quote.div(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.min(base, quoteToBase).toDecimalPlaces((_c = symbol.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
};
exports.maxDumping = maxDumping;
/**获取市价单最小下单额（投quote） */
const minSpending = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.amount.min) || 0);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.spending.min) || 0);
    const baseToQuote = base.mul(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.max(baseToQuote, quote).toDecimalPlaces((_c = symbol.precision) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
};
exports.minSpending = minSpending;
/**
 *  获取市价单最大下单额(投quote)
 */
const maxSpending = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.amount.max) || Number.MAX_VALUE);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.spending.max) || Number.MAX_VALUE);
    const baseToQuote = base.mul(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.min(baseToQuote, quote).toDecimalPlaces((_c = symbol.precision) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
};
exports.maxSpending = maxSpending;
